import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";
import Logo from "@/components/Logo";

// Spanish-only Thank You page at /thank_you
export default function ThankYouPage() {
  useEffect(() => {
    document.title = "¡Gracias! — Mirexiluna";
    document.documentElement.lang = "es-AR";
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F3EA] text-[#0F1B2D] flex flex-col">
      <header className="border-b border-[#e6dfcf]">
        <div className="mx-auto max-w-6xl px-5 h-16 flex items-center">
          <Link to="/" className="flex items-center" data-testid="thanks-logo">
            <Logo />
          </Link>
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="max-w-lg w-full text-center">
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-[#0F1B2D] text-[#E9B949] mx-auto">
            <CheckCircle2 className="h-8 w-8" />
          </span>
          <h1 className="mt-6 text-[32px] md:text-[40px] font-semibold tracking-tight leading-tight">
            ¡Gracias por escribirnos!
          </h1>
          <p className="mt-4 text-[15px] leading-relaxed text-[#4b5563]">
            Recibimos tu mensaje. Nuestro equipo lo revisará y te responderá en un plazo estimado de 24 a 48 horas hábiles.
          </p>
          <Link
            to="/"
            data-testid="thanks-back-home"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0F1B2D] px-5 py-3 text-[14px] font-semibold text-[#F7F3EA] hover:bg-[#1c2c46] transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver al inicio
          </Link>
        </div>
      </main>
      <footer className="border-t border-[#e6dfcf]">
        <div className="mx-auto max-w-6xl px-5 py-6 text-[12px] text-[#4b5563]">
          © {new Date().getFullYear()} Mirexiluna Capital Urbano S.A.S.
        </div>
      </footer>
    </div>
  );
}
